import { Link } from "react-router-dom";
import API from "../config/api.js";

export default function CourseCard({ course }) {
  const getImageUrl = (path) => {
    if (!path) return "/assets/img/624x427.png";
    return `${API.baseUrl}/${path.replace("original.jpg", "624x427.jpg")}`;
  };

  const imageSrc = getImageUrl(course.image);
  const isActive = Number(course.active) === 1;
  const lessons = Number(course.lessons || 0);
  const lessonsCompleted = Number(course.lessonscompleted || 0);
  const isCompleted = lessons > 0 && lessons === lessonsCompleted;
  const isStarted = lessonsCompleted >= 1;

  const getDaysRemaining = (launchDate) => {
    if (!launchDate) return null;

    const today = new Date();
    const launch = new Date(launchDate);

    if (Number.isNaN(launch.getTime())) return null;

    const diffTime = launch.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 0 ? diffDays : 0;
  };

  const daysRemaining = getDaysRemaining(course.launchdate);
  const courseUrl = `/course?idcourse=${course.idcourse}`;

  return (
    <div
      className={`card rounded-4 h-100 course-${course.idcourse} animate__animated animate__fadeIn animate__slow`}
    >
      <div className="p-2">
        <div className="position-relative">
          {!isActive ? (
            <>
              <img
                src={imageSrc}
                alt={course.title || ""}
                className="img-fluid w-100 bg-loading rounded-3 grayscale"
                width="624"
                height="427"
                onError={(e) => {
                  e.currentTarget.src = "/assets/img/624x427.png";
                }}
              />
              <div className="position-absolute border rounded-3 h-100 text-center p-3 w-100 top-0 start-0 end-0">
                <div className="position-absolute top-50 start-50 translate-middle w-100 text-center p-3 fs-5 text-white fw-bold">
                  <i className="fi fi-rr-lock fs-1"></i>
                </div>
              </div>
            </>
          ) : (
            <Link to={courseUrl}>
              <img
                src={imageSrc}
                alt={course.title || ""}
                className="img-fluid w-100 bg-loading rounded-3"
                width="624"
                height="427"
                onError={(e) => {
                  e.currentTarget.src = "/assets/img/624x427.png";
                }}
              />
            </Link>
          )}
        </div>
      </div>

      <div className="card-header border-bottom-0 bg-transparent p-2 px-md-3">
        <h2
          className="card-title fs-6 mb-0"
          style={{
            lineHeight: "1.5em",
            height: "3em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {course.title}
        </h2>
      </div>

      <div className="card-body pt-0" style={{ overflowY: "hidden" }}>
        <p>
          <i className="fi fi-rr-clock" style={{ verticalAlign: "text-bottom" }}></i>{" "}
          {course.duration || "Coming soon"}
        </p>
        <p>{course.description}</p>
      </div>

      <div className="card-footer border-top-0 bg-transparent p-3 w-100">
        {!isActive ? (
          course.launchdate && daysRemaining !== null && daysRemaining > 0 ? (
            <button type="button" className="btn btn-light w-100" disabled>
              Available in {daysRemaining} days
            </button>
          ) : (
            <button type="button" className="btn btn-secondary w-100" disabled>
              Coming Soon
            </button>
          )
        ) : isCompleted ? (
          <Link className="btn btn-success w-100" to={courseUrl}>
            Completed
          </Link>
        ) : isStarted ? (
          <Link className="btn btn-secondary w-100" to={courseUrl}>
            Continue
          </Link>
        ) : (
          <Link className="btn btn-secondary w-100" to={courseUrl}>
            Get Started
          </Link>
        )}

        <div className="mt-3 d-none">
          <div className="progress" style={{ height: "8px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: "25%" }}
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}